import { createClient, SupabaseClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_ANON_KEY

// 환경변수 검증 — 빌드 시점 정합 보장
export const supabase: SupabaseClient | null =
  url && key ? createClient(url, key) : null

export const SUPABASE_AVAILABLE = Boolean(url && key)
